import React, { useState } from "react";
import SalesLineChart from "./salesCharts";
import PieChartWithCustomizedLabel from "./salesCharts/paymentMethodChart";
import VerticalComposedChart from "./salesCharts/verticalStoresLine";
import OrdersBarChart from "./ordersCharts/ordersOverTime";
import StoreRadarChart from "./storesCharts/radarStoresChart";
import StoresLineChart from "./storesCharts/storesLineChart";
import BestStores from "./storesCharts/bestStores";
import WorstStores from "./storesCharts/worestStores";
import DataTable from "../UI/table/DataTable";
import StatusStore from "../UI/statusStore";
import TableActions from "../UI/table/TableActions";
import { deleteStores, getStores } from "../../MyApi/stores";
import { useQuery } from "react-query";
import SkeletonWrapper from "../UI/skeletonWrapper";

const StoresReportsTab = ({ statsWidget, isLoading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const { data, isLoading:storesLoading, refetch, isFetching } = useQuery(
    ["getStores", currentPage],
    () => getStores(currentPage),
  );

  const stores = data?.data?.Stores || [];
  const storeColumns = [
    {
      label: "معرف المتجر",
      render: (row) => <div className="text-green"> #{row.id}</div>,
    },
    { label: "اسم المتجر", accessor: "name" },
    { label: "مالك المتجر", accessor: "owner_name" },
    { label: "القسم", accessor: "section_name" },
    { label: "رقم الجوال", accessor: "phone" },
    { label: "عدد الفروع", accessor: "count_branches" },
    { label: "عدد الطلبات", accessor: "count_orders" },
    {
      label: "التقييم",
      render: (row) => `${row.avg_rate ?? 0} ★`,
    },
    {
      label: "الحالة",
      render: (row) => <StatusStore status={row.active_status} />,
    },
    {
      label: "آخر تحديث",
      render: (row) => new Date(row.updated_at).toLocaleDateString("ar-EG"),
    },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
          show={`${process.env.PUBLIC_URL}/store/${row.id}`}
          edit={`${process.env.PUBLIC_URL}/stores/edit/${row.id}`}
          refetch={refetch}
          id={row.id}
          deleteFn={deleteStores}
          deletePermission={"delete_store"}
          viewPermission={"view_store"}
          editPermission={"update_store"}
        />
      ),
    },
  ];

  return (
    <div>
      <SkeletonWrapper isLoading={isLoading}>
        <div className="col-12">
          <OrdersBarChart
            data={statsWidget?.charts?.top_stores_by_revenue}
            dataKeyX="name"
            dataKeyY="revenue"
            barColor="#FFCC03"
            title={"أفضل 10 متاجر من حيث المبيعات"}
            name={"المبيعات"}
          />
        </div>
      </SkeletonWrapper>

      <div className="row">
        <div className="col-md-6">
          <SkeletonWrapper isLoading={isLoading}>
            <StoreRadarChart
              performance_radar={statsWidget?.charts?.performance_radar || {}}
            />
          </SkeletonWrapper>
        </div>
        <div className="col-md-6">
          <SkeletonWrapper isLoading={isLoading}>
            <StoresLineChart
              data={statsWidget?.charts?.store_registration_trend || []}
            />
          </SkeletonWrapper>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <SkeletonWrapper isLoading={isLoading}>
            <BestStores data={statsWidget?.charts?.top_performing_stores || []}  currency_factor={statsWidget?.currency_factor} currency_code={statsWidget?.currency_code} />
          </SkeletonWrapper>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <SkeletonWrapper isLoading={isLoading}>
            <WorstStores data={statsWidget?.charts?.low_performing_stores ||[]}  />
          </SkeletonWrapper>
        </div>
      </div>


        <DataTable
          columns={storeColumns}
          data={stores || []}
          title="المتاجر"
          totalItems={data?.data?.pagination?.total || 0}
          itemsPerPage={data?.data?.pagination.last_page}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          isLoading={storesLoading}
          isFetching={isFetching}
        />
 
    </div>
  );
};

export default StoresReportsTab;
